export const UNIT_LIST_PATHS = {
  units: "/units",
  manageunits: "/manageunits",
  alerts: "/alerts",
  dashboard: "/dashboard",
};

/**
 * Record which unit list a unit was opened from, along with the sort, filter
 * and page state that list was showing, so the user can be returned to it
 *
 */
export const unitListReturnState = (from, search) => ({ from, search });

/**
 * Resolve the unit list to return to after configuring or editing a unit,
 * including the sort, filter and page the user left it on
 *
 */
export const unitListReturnPath = (state, defaultPath = UNIT_LIST_PATHS.units) => {
  const listPath = UNIT_LIST_PATHS[state?.from];

  if (!listPath) {
    return defaultPath;
  }

  return `${listPath}${state?.search || ""}`;
};
